import {useContext, useEffect, useState} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import styles from "./TenantUserDetailModal.module.css";
import {IAM_SERVER_TENANT_USER} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import Loading from "../../../utils/loading/Loading";
import { InnocodeButton, InnocodeInput } from "@intsoft/innocode-core";


/**
 * 사용자 상세정보 모달 Container
 * @param id
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const TenantUserDetailModal = ({data, canManageTenantUser, update, onDelete}) => {

    const {closeModal} = useContext(ModalContext);

    console.log("[TenantUserDetailModal] render", {
        data,
        canManageTenantUser,
    });

    const [formData, setFormData] = useState({
        tenantUserId: data.tenantUserId,
        tenantType: data.tenantType
    });

    const fetchData = async () => {
    }

    useEffect(() => {
        fetchData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
            }));
    };


    // 사용자 상세정보 수정 요청 API
    const handleModify = () => {
        console.log("[TenantUserDetailModal] handleModify", {
            canManageTenantUser,
            tenantType: data.tenantType,
            formTenantType: formData.tenantType,
            data,
        });

        if(!canManageTenantUser){
            closeModal();
            return;
        }

        axios.post(`${IAM_SERVER_TENANT_USER}/update`, {
            tenantUserId: data.tenantUserId,
            tenantType: formData.tenantType,
        })
            .then(() => {
                showDialog(DialogEnum.SUCCESS, "성공", "테넌트 유저 정보가 수정되었습니다.", () => {
                    update();
                    closeModal();
                });
            })
            .catch(() => {
                showDialog(DialogEnum.DEFAULT, "오류", "테넌트 유저 정보를 수정하는 데 실패했습니다.");
            });
    };

    
    const handleDelete = () => {
        console.log("[TenantUserDetailModal] handleDelete", {
            canManageTenantUser,
            tenantType: data.tenantType,
            data,
        });

        const confirmText = "테넌트 유저를 탈퇴 하시겠습니까?";

        showDialog(DialogEnum.CONFIRM, "테넌트 유저 탈퇴 확인", confirmText, async () => {
            const url = `${IAM_SERVER_TENANT_USER}/delete/${data.tenantUserId}`;

            await axios.post(url)
                .then((res) => {
                    showDialog(DialogEnum.SUCCESS, "완료", "테넌트 유저를 탈퇴 완료");
                    update();
                })
                .catch((e) => {
                    showDialog(DialogEnum.DEFAULT, "오류", "테넌트 유저를 탈퇴 중 오류가 발생했습니다.");
                });
        });
    }


    return (
        <div className={styles.modalContainer}>
            <div>
                <ul className={styles.layer__listWrap}>
                    <li className={styles.layer__list}>
                        <p className={styles.layer__listTit}>
                            프로필 명
                        </p>
                        <InnocodeInput
                            // className={styles.layer__listInput}
                            type="text"
                            name="profileName"
                            value={data.profileName}
                            disabled={true}
                            onChange={handleChange}
                        />
                    </li>
                    <li className={styles.layer__list}>
                        <p className={styles.layer__listTit}>
                            유저 아이디
                        </p>
                        <InnocodeInput
                            // className={styles.layer__listInput}
                            type="text"
                            name="unifiedProfileId"
                            value={data.unifiedProfileId}
                            disabled={true}
                            onChange={handleChange}
                        />
                    </li>
                    <li className={styles.layer__list}>
                        <p className={styles.layer__listTit}>권한</p>
                        { !canManageTenantUser ?
                            <InnocodeInput
                                // className={styles.layer__listInput}
                                type="text"
                                name="tenantType"
                                value={data.tenantType}
                                disabled={true}
                            />
                            :
                            <select
                                className={styles.layer__listInput}
                                name="tenantType"
                                value={formData.tenantType}
                                onChange={handleChange}
                            >
                                <option value="manager">관리자 (Manager)</option>
                                <option value="user">일반 유저 (User)</option>
                            </select>
                        }
                    </li>
                </ul>

                <div className={styles.layer__sensorBtnBox}>
                    { canManageTenantUser &&
                        <InnocodeButton
                            size="md"
                            designType="primary"
                            fullWidth={true}
                            backgroundColor="var(--status-negative, #f83a3a)"
                            onClick={handleDelete}
                            className={styles.actionBtn}
                        >
                            탈퇴
                        </InnocodeButton>
                        // <button className={styles.layer__cancleBtn} onClick={handleDelete}>탈퇴</button>
                    } 
                    <InnocodeButton
                        size="md"
                        designType="primary"
                        fullWidth={true} 
                        onClick={handleModify}
                        className={styles.actionBtn}
                    >
                        {canManageTenantUser ? '저장' : '확인'}
                    </InnocodeButton>
                    {/* <button className={styles.layer__modifyBtn} onClick={handleModify}>
                        {data.tenantType !== 'owner' ? '저장' : '확인'}
                    </button>                         */}
                </div>                    
            </div>
        </div>
    );
}
